import { render, staticRenderFns } from "./RegionalPricesField.vue?vue&type=template&id=7220c316&scoped=true&"
import script from "./RegionalPricesField.vue?vue&type=script&lang=js&"
export * from "./RegionalPricesField.vue?vue&type=script&lang=js&"
import style0 from "./RegionalPricesField.vue?vue&type=style&index=0&id=7220c316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7220c316",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VRow,VSelect,VTextField,VTooltip})
